<template>
	<v-app>
		<router-view />
	</v-app>
</template>

<script>
export default {
	data: () => ({
	}),
  methods: {
    // onResize () {
    //   window.isMobile = window.innerWidth < 600
    //   console.log('resized: isMobile: ' + window.isMobile)
    // },
    showSuccessNotification: function (message) {
      // console.log('success: ' + message)
      this.notificationBar.message = message
      this.notificationBar.type = 'success'   // 'success' or 'error'
      this.notificationBar.show = true
    },
    showErrorNotification: function (message) {
      // console.log('error: ' + message)
      this.notificationBar.message = message
      this.notificationBar.type = 'error'   // 'success' or 'error'
      this.notificationBar.show = true
    }
  },
  // beforeDestroy () {
  //   if (typeof window !== 'undefined') {
  //     window.removeEventListener('resize', this.onResize, { passive: true })
  //   }
  // },
  // mounted () {
  //   this.onResize()
  //   window.addEventListener('resize', this.onResize, { passive: true })
  // },
};
</script>

<style>
body {
  font-family: 'Roboto', "Microsoft YaHei","微软雅黑","Hiragino Sans GB","STHeiti","WenQuanYi Micro Hei",SimSun, sans-serif !important;
	background-color: #CCC !important;
}
#app,
#app .v-application .headline,
#app .v-application .title,
.v-application .v-card .title {
  font-family: 'Roboto', "Microsoft YaHei","微软雅黑","Hiragino Sans GB","STHeiti","WenQuanYi Micro Hei",SimSun, sans-serif !important;
}
/* Begin Veutify Rewrite */
.v-btn--contained {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.v-btn {
  /*text-transform: none !important;*/
}
/* End Veutify Rewrite */
.page-title {
	font-size: 28px;
	margin: 10px;
	color: #656565;
}
.v-application .headline {
	/*font-size: 1.35rem !important;*/
	font-weight: 500 !important;
}
.top-right-close {
	position: absolute;
	top: 15px;
	right: 15px;
	font-size: 23px;
	color: #444;
}
.nowrap {
  white-space: nowrap
}
.clickable {
	cursor: pointer;
}
.token-info-wrapper {
	display: inline-block;
}
.color-green {
	color: #26a65b !important;
}
.bg-green {
	background-color: #caefc4;
},
.color-gray {
	color: #c3c3c3 !important;
}
.bg-gray {
	background-color: #EDEDED;
}
.order-amount-wrapper {
  display: inline-block;
  background-color: #FFF;
  padding: 3px 8px 3px 10px;
  border-top: 1px solid #CCC;
  border-right: 1px solid #CCC;
  border-bottom: 1px solid #CCC;
  margin-left: -3px;
}
.order-price-wrapper {
  display: inline-block;
  background-color: #FFF;
  padding: 0px 8px;
  border: 1px solid #CCC;
}
.theme--dark .order-amount-wrapper {
  background-color: #373737;
  border-top: 1px solid #747474;
  border-right: 1px solid #747474;
  border-bottom: 1px solid #747474;
}
.theme--dark .order-price-wrapper {
  background-color: #373737;
  border: 1px solid #747474;
}
.empty-page-content {
  margin: 100px auto;
}
.help-panels .v-expansion-panel-header {
  padding: 0px 20px !important;
  min-height: 40px !important;
  line-height: 1.5rem !important;
}
.help-panels .v-expansion-panel-header .title {
  font-size: 1rem !important;
}
.help-panels .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 50px !important;
  padding-top: 5px !important;
  font-weight: bold !important;
}
.help-panels .v-expansion-panel-content__wrap {
  padding: 12px 20px 12px !important;
}
</style>
